import Hero from "../../components/Hero/Hero";
import About from "../../components/About/About";
import Featured from "../../components/Featured/Featured";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Pricing from "../../components/Pricing/Pricing";
import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import Features from "../../components/Features";
import Contact from "../../components/Contact";
import AOS from "aos";
import { useEffect } from "react";

const HomePage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Header />
      <main className="main">
        <Hero />
        <About />
        <Featured />
        <Features />
        <Pricing />
        <Contact />
      </main>
      <Footer />
      <ScrollToTopButton />
    </>
  );
};

export default HomePage;
